import script from "./middleDocument.vue?vue&type=script&lang=ts&setup=true"
export * from "./middleDocument.vue?vue&type=script&lang=ts&setup=true"

import "./middleDocument.vue?vue&type=style&index=0&id=6613fe74&scoped=true&lang=css"
import "./middleDocument.vue?vue&type=style&index=1&id=6613fe74&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6613fe74"]])

export default __exports__